/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Display_New_Folder_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to create folder: {error}" |
*
* @param {Explorer_Display_New_Folder_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_failed_toast = /** @type {((inputs: Explorer_Display_New_Folder_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de creation du dossier : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ordner konnte nicht erstellt werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile creare la cartella: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось создать папку: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al crear la carpeta: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`创建文件夹失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`フォルダの作成に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ़ोल्डर बनाने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao criar a pasta: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to create folder: ${i?.error}`)
});